/*
 * Copyright (C) 2026 to Present Applause App Quality, Inc. All rights reserved.
 */

import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

const SIZE = 120;
const STROKE = 8;
const RADIUS = SIZE / 2 - STROKE / 2;
// The meter is a three-quarter ring.
const ARC = 2 * Math.PI * RADIUS * 0.75;

// The Profile Completion card: the tester's avatar inside a ring showing how complete their profile is.
@Component({
  selector: 'ut-dashboard-profile-completion',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './dashboard-profile-completion.component.html',
  styleUrls: ['./dashboard-profile-completion.component.scss'],
})
export class DashboardProfileCompletionComponent {
  @Input({ required: true }) user: any;
  @Input() testerAppUrl = '';

  readonly size = SIZE;
  readonly center = SIZE / 2;
  readonly radius = RADIUS;
  readonly stroke = STROKE;
  readonly arc = ARC;

  get percent(): number {
    return this.user?.tester_profile_completion_percentage || 0;
  }

  get dashOffset(): number {
    return ARC * (1 - this.percent / 100);
  }
}
